/**
 * Loads all the JS supplied by the designer for interactive elements.
 */
define(
  'app/design',[
    'jquery', 'jquery.isOnScreen', 'jquery.bjqs', 'jquery.noUiSlider',
    'jquery.formatCurrency', 'main','jquery.bxslider'
  ], function(jquery, jqos, bjqs, jqnouislider, jqformatcurrency, main ,bxslider) {
  }
);

